import React from 'react';
import PropTypes from 'prop-types';
import ChannelHeader from 'components/atoms/header/ChannelHeader';
import breakpoint from 'styled-components-breakpoint';
import { withBreakpoints } from 'react-breakpoints';

import styled from 'styled-components';

const ChannelHeaderFlex = styled.div`
    ${() => breakpoint('sm')`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `}

     @media print {
        display: auto;
    }
`;

const ChannelActionsWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;

    /* this will put a horizontal separator between each button, but not on the last button */
    button::after {
        content: "";
        display: block;
        margin: 0px 20px;
        width: 1px;
        height: 30px;
        background: ${props => props.theme.colors.gray};
    }; 

    button:last-child {
        ::after {
            content: none;
        }
    }

`;

const ChannelHeaderStyled = styled(ChannelHeader)`
    margin-right: 10px;
`;

const ChannelTitle = ({ children, print = null, currentBreakpoint, breakpoints }) => (
    <React.Fragment>
        {print && breakpoints && breakpoints[currentBreakpoint] >= breakpoints.sm ?
            <ChannelHeaderFlex>
                <ChannelHeaderStyled>{children}</ChannelHeaderStyled>
                <ChannelActionsWrapper>{print}</ChannelActionsWrapper>
            </ChannelHeaderFlex>
            :
            <ChannelHeader>{children}</ChannelHeader>
        }
    </React.Fragment>
);

ChannelTitle.propTypes = {
    print: PropTypes.any,
    breakpoints: PropTypes.object,
    currentBreakpoint: PropTypes.string,
};

export default withBreakpoints(ChannelTitle);



// WEBPACK FOOTER //
// ./src/components/atoms/layout/ChannelTitle.js